import { render, staticRenderFns } from "./ResultKmcTpsPop.vue?vue&type=template&id=2ca2c1f1&scoped=true&"
import script from "./ResultKmcTpsPop.vue?vue&type=script&lang=js&"
export * from "./ResultKmcTpsPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2c1f1",
  null
  
)

export default component.exports